const headers = {
  name: "Contacts",
  navigate: {
    path: [
      {
        name: "Contacts",
        path: "/app/contacts",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
